/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getActorMetadata.defs.js'
export { main as default } from './getActorMetadata.defs.js'
